module.exports = __webpack_public_path__ + "assets/toolbar-settings-icon-active.017aed66.svg";